module.exports = __webpack_public_path__ + "static/media/8OLA20.f87ac7bc.jpg";